import axiosInstanceBuilder from "../config/axios/axiosInstanceBuilder";
import { useFetch } from "../config/axios/useFetch";
import axios from "axios";
import { useSelector } from "react-redux";

const baseUrl = process.env.REACT_APP_API_DEV_URL;

export const useUserPersonalInfo = (callAfterMount = false) => {
  const ubaToken = useSelector((state) => state.ubaToken.ubaToken);

  const createAxiosPromise = () => {
    const tk = ubaToken?.tokenFromUrl;
    const isUbaUser = Boolean(tk);
    const endpoint = isUbaUser ? "/uba/users/info" : "/users/info";
    const url = `${baseUrl}${endpoint}`;
    const axiosClient = isUbaUser ? axios : axiosInstanceBuilder(baseUrl);
    const config = isUbaUser ? { params: { tk } } : undefined;

    return axiosClient.get(url, config);
  };

  const { data, isPending, error, fetchApi } = useFetch(
    createAxiosPromise,
    callAfterMount
  );

  const getUserPersonalInfo = async () => {
    const response = await fetchApi();
    const { data, ...rest } = response;
    return {
      firstName: data.first_name,
      lastName: data.last_name,
      acceptedPolicy: data.accepted_policy,
      email: data.email,
      ...rest,
    };
  };

  return {
    userRole: data,
    isLoading: isPending,
    error,
    getUserPersonalInfo,
  };
};
